import Select, { components } from "react-select";
import { ReactComponent as VenueIcon } from '@/assets/icons/ri-map-pin-2-fill.svg'
import { ReactComponent as RiArrowDownSLine } from '@/assets/icons/ri-arrow-down-s-line.svg';

const IndicatorsContainer = () => <div className="text-black-primary">
    <RiArrowDownSLine />
</div>

const Control = ({ children, useIcon, ...props }) => (
    // @ts-ignore
    <components.Control {...props}>
         <div className="flex flex-row justify-start items-center gap-1 py-2 px-4 text-black-primary text-jsm font-medium h-10 min-w-[300px]">
             {useIcon ? <div className="text-red-primary h-6 w-6">
                 <VenueIcon />
             </div> : <></>}
             {children}
         </div>
    </components.Control>
);

const IndicatorSeparator = () => null

const UserVenueSelect = ({useIcon = true, ...props}) => <Select
    {...props}
    components={{
        Control: (p) => Control({...p, useIcon}),
        IndicatorsContainer,
        IndicatorSeparator,
    }}
/>

export default UserVenueSelect;